import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const fetchUnmappedRegions = async (bedFileId) => {
  const { data } = await axios.get(`${API_BASE_URL}/bed/unmapped/${bedFileId}`)
  return data
}
